module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap"
  }, [_vm._v("GETTING STARTED")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Small but refined")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("S")]), _vm._v("mall gardens, when compared with a similarly sized area within a large garden, encourage and need greater gardening involvement, especially when creating a well-admired display throughout the year. Parts of a large garden often escape rigorous and detailed assessment from visitors and there is always the explanation of it being too large. Within a small garden, you must be prepared for continuous and detailed involvement.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Will it need less attention?")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("OPPORTUNITIES AND CONSTRAINTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Constructing a lightly shaded patio, perhaps alongside raised beds and with a small pond generating summer interest, is idyllic – and just one opportunity in a small garden. Additionally, there are plants in containers, many colorful and fragrant and acting as reminders of warmer climates. Therefore, be prepared to spend more money than for an equivalent area in a larger garden. Small is beautiful, but sometimes more expensive.")]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("WHAT’S POSSIBLE?")])]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Clearly, garden features that demand unrestricted space are not possible in a small or even moderately sized garden, but many others can be considered. Some of these have a novel nature that would be too expensive to attempt on a large scale, but in a restricted area are just right. These include Japanese and Mediterranean gardens, as well as checkerboard and cartwheel herb gardens. There are many other features to consider – see "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_4"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0003-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0003-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0003-01"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Beds and borders alongside houses can be drenched in color throughout summer. Use a range of plants, from summer-flowering bedding plants to herbaceous perennials.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0003-01"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0003-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0003-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0003-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Spring-flowering bulbs, such as bright-faced Daffodils in a variety of containers, are also welcome.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("LAWN OR PATIO?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In many gardens, both a lawn and a patio are practical features. A lawn unites a garden and creates an attractive foil for borders and beds, whereas a patio is much needed as a year-round, all-weather surface, as well as for summer relaxation. Therefore, in a small garden it is a lawn that is least necessary. This also saves on the storage of lawn tools and mowers – and, perhaps, fuel.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("CREATING SPACE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Even in a small garden it is possible to create an impression of space. Aim to have an open area in the center of the garden, surrounded by plants or features that do not obstruct views to the full extent of the garden. Ponds encourage a perception of space, with the benefit of reflected light creating an impression of an even larger area.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("CREATING SURPRISE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There is a delicate balance in a small garden between creating space and ensuring surprise. Both are essential and the surprise element is best near to the edges of the garden, where perhaps a small leaf-clad arch or screen can be combined with perimeter fencing or a wall. A free-standing trellis, dressed with leafy or flowering climbers, is another way to create surprise.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("CREATING PRIVACY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Quiet areas are essential in gardens and privacy has healing and supportive properties. Contemplative areas encourage relaxation; leafy vertical and overhead screens ensure seclusion, especially in summer and when covered with leaves. "), _c('em', [_vm._v("Humulus lupulus")]), _vm._v(" ‘Aureus’ (Yellow-leaved Hop) is ideal for summer privacy; for all-year screening large-leaved variegated Ivies are better.")])]), _c('div', {
    staticClass: "boxb"
  }, [_c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Need a shed?")])]), _c('p', {
    staticClass: "paras"
  }, [_c('a', {
    attrs: {
      "id": "imgf0003-02"
    }
  }, [_c('em', [_vm._v("In a large garden, a shed is essential as a place for keeping tools, pots and composts, as well as other equipment. In a small garden, consider a combined summerhouse and shed, or even just rely on a garage, if you have one. See ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 76")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Types of small gardens")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("O")]), _vm._v("pportunities for creating an exciting but small garden are wide, and apart from vast vistas there are styles and designs to suit most tastes, but on a reduced scale. On these pages there is a pictorial display of a range of diminutive gardens, with descriptions and ideas for many others. Few small gardens are totally devoted to one of these styles, but nevertheless they provide an insight into ways to make a small garden beautiful, functional and exciting.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Does small mean restricted opportunities?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("SMALL-GARDEN STYLES")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Informal")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0004-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0004-01"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("These have a casual feel that encourages a relaxed and informal ambience. There is nothing symmetrical about them. Instead, beds are irregularly shaped, with curved patios and informal paths. Shrubs and trees have relaxed habits, with other plants creating further informality. Avoid the creation of straight lines.")])])]), _c('a', {
    attrs: {
      "id": "imgf0004-01"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Formal")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0004-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0004-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0004-04"
    }
  }), _c('p', {
    staticClass: "captiona"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-04"
    }
  }, [_vm._v("Gardens with a formal nature have straight or clinically curved lines, produced by plants as well as paths and patio edges. Regimentation is often produced by seasonal plants, such as bulbs and biennials in spring displays and half-hardy bedding plants throughout summer. Such gardening enables color schemes to be changed from one year to another (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Mediterranean")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0004-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0004-02"
    }
  }), _c('p', {
    staticClass: "captiona"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-02"
    }
  }, [_vm._v("With the onset of warmer summers, many gardeners nostalgically like to recall the endless blue skies, warm breezes and little rain of Mediterranean vacations. Choose a combination of plants in pots, window boxes and hanging baskets, with shrubs that have silver-colored or aromatic leaves. Silver leaves reflect hot sunshine, while aromatic leaves create a barrier of oils above their surfaces (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 24")]), _vm._v(").")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Japanese gardens exude peace, serenity and contemplation. They have a simple yet planned nature, with involvement from gravel, water, small trees, bamboos and plants in containers. Diminutive fountains and ponds are sometimes possible in small gardens, but if this is difficult the illusion of flowing water can be created by colored shale (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 25")]), _vm._v(").")]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("English-style flower borders")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0004-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0004-03"
    }
  }), _c('p', {
    staticClass: "captiona"
  }, [_c('a', {
    attrs: {
      "id": "imgf0004-03"
    }
  }, [_vm._v("This type of flower border has a relaxed, informal and floriferous nature throughout summer. The borders are packed mostly with herbaceous plants that die down in autumn and send up fresh shoots in spring (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_18"
    }
  }, [_vm._v("here")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("WATER GARDENING")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The shape and extent of a garden pond can be matched to a garden’s size as well as its style. If space is a problem, consider a miniature pond in a tub or a pebble feature with water gently splashing onto pebbles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This design is ideal for homes with young, inquisitive children who could easily fall into a large pond.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("You can use fountains – as well as water spouting out of a wall-secured feature such as a lion’s head – to create height. However, try to ensure that water does not splash onto any Waterlily flowers.")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_vm._v("FRONT GARDENS")])]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Even the narrowest and smallest front garden can be made attractive. If a small, grassed area is not possible, paving with cobbles in an attractive pattern creates a base for plants in containers (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(" for ideas).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paras"
  }, [_vm._v("If flower beds are possible, create height by planting a standard rose; even better, if space allows, use a weeping rose that will harmonize with ornate, older-style properties.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paras"
  }, [_vm._v("Where standing areas for cars have meant the demolition of front gardens, consider gravel or paving slabs. Flexible pavers on a thick base can also be used.")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Plants in containers revitalize front gardens")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }), _c('div', {
    staticClass: "w-blue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("CONTAINER GARDENING")])])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0005-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-02"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Window boxes drench windows in radiant color")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-02"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0005-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-03"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Hanging baskets create color at eye height")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-03"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0005-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-04"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Strawberries in pots always attract attention")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-04"
    }
  }), _c('p', {
    staticClass: "paras1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-04"
    }
  }, [_vm._v("Few facets of gardening are as popular and versatile as growing plants in containers and positioning them in an attractive way on patios and in other places around a house. Some displays are seasonal, while shrubs, trees and bamboos in tubs become permanent features (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("BALCONIES AND ROOF GARDENS")])]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Balconies are more popular than roof gardens, which for practical purposes demand strong, waterproof flooring (permission may be needed for its use). Many apartments, however, have balconies that are ideal for plants in containers. Ensure that plants cannot fall from the balcony, or be dislodged by violent storms. Positioning troughs on the balcony’s base and allowing stems to trail through the balustrade creates color which can be admired from below.")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-05"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Balconies are easily covered with color")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-05"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-05"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-05"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0005-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Roof gardens are superb during summer")])])])]), _c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("LOW-MAINTENANCE GARDENS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whatever a garden’s size, short-cut and time-saving gardening is essential for families with busy lifestyles. A garden’s design and the use of mechanical equipment can ease time pressures. For example, installing lawn edgings that suit equipment used to trim long grass saves many hours of work throughout a year. Within this book there are ideas about easy gardening maintenance.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("SECLUDED AND PRIVATE GARDENS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Increasingly, gardens are outdoor living areas, and to enable them to function in this way seclusion and privacy are essential. Privacy up to head height is easily created by screens, fences and walls, but where neighbors are able to peer from overhead, the creation of seclusion is more difficult. Proprietary awnings attached to a house are useful, while leafy pergolas are another solution. Constructing an arbor a little way into a garden is another possibility.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("FOOD-PRODUCING GARDENS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Growing vegetables and fruits in containers never fails to attract attention in small gardens. Apple trees are possible in tubs and large pots, strawberries in barrels and hanging baskets, and potatoes, lettuces and tomatoes in grow bags. In small areas – perhaps against fences and walls – cordon, espalier and fan-trained fruit trees are space-savers.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("WILDLIFE GARDENS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Wildlife gardens do not have to be large to attract butterflies and other insects, as well as birds and small mammals.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Healing gardens")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Plants have a significant influence on our lives, and not just through their well-publicized medicinal qualities. The colors of flowers influence lives. For example, massed red is claimed to raise blood pressure and increase pulse rates, while blue has a soothing effect. Fragrance, sound, shape and texture also influence our lives.")])])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec3"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0005-06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Range of plants for small gardens")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("M")]), _vm._v("any plants are suitable for small gardens. They range from bulbs and diminutive rock garden plants to herbaceous perennials, summer-flowering bedding plants and miniature and slow-growing dwarf conifers. Additionally, there are superbly attractive small shrubs and trees for space-restricted areas, but they need to be selected with greater care than those plants that are naturally short-lived and can be easily replaced within a few years.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("What types of plants are best?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0006-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0006-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0006-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("An eye-catching combination of handsome foliage and flowers.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0006-01"
    }
  }, [_c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("How long do plants live?")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_c('em', [_vm._v("Some plants are ephemeral and are replaced during the following year, while others are woody and live for many years.")])]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Annuals: "), _c('em', [_vm._v("short-lived")])]), _vm._v(" – raised from seeds; they produce flowers and die during the same year.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Biennials: "), _c('em', [_vm._v("two seasons")])]), _vm._v(" – raised from seeds one year and flower and die during the following year.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Herbaceous perennials: "), _c('em', [_vm._v("3–4 years before division is needed")])]), _vm._v(" – plants die down to ground level each autumn and reappear during the following spring.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Shrubs: "), _c('em', [_vm._v("10 or more years")])]), _vm._v(" – woody, perennial plants with stems growing from soil level and without a trunk.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Trees: "), _c('em', [_vm._v("20 or more years")])]), _vm._v(" – woody, with a single stem (trunk) joining the branches to the roots.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Climbers:")]), _vm._v(" annual (see above), herbaceous (see above) or woody and perennial, and living for "), _c('em', [_c('strong', [_c('em', [_vm._v("10 or more years")])])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Conifers: "), _c('em', [_vm._v("15 or more years")])]), _vm._v(" – either tree or shrub-like, with an evergreen or deciduous nature.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Bamboos: "), _c('em', [_vm._v("15 or more years")])]), _vm._v(" – thicket-forming, with stiff, upright, hollow stems.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Rock garden plants: "), _c('em', [_vm._v("3 or more years")])]), _vm._v(" – range of types, from alpines to small border perennials.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("Bulbs: "), _c('em', [_vm._v("short-lived")])]), _vm._v(" – but produce further bulbs around them that develop into flowering-size bulbs.")])])]), _c('div', {
    staticClass: "boxb"
  }, [_c('a', {
    attrs: {
      "id": "imgf0006-01"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Plants to seek")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_c('em', [_vm._v("With such a wide range of plants available, it can be difficult to make a successful selection. Here are a few tips for a small garden.")])])]), _c('p', {
    staticClass: "bullets1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0006-01"
    }
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Rapid establishment")]), _vm._v(" is essential to ensure that the garden is soon cloaked in colorful and attractively shaped plants. Quick establishment depends on thorough pre-planting soil preparation and buying healthy plants (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_15"
    }
  }, [_vm._v("page 15")]), _vm._v(" for what to look for when buying).")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Slow-growing plants")]), _vm._v(" ensure that their neighbors – as well as the garden in general – are not rapidly swamped with branches and stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Non-invasive plants")]), _vm._v(" are essential in small gardens to ensure that they will neither block drains nor quickly spread into neighboring gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Plants with two or more display qualities")]), _vm._v(" are desirable when creating attractive gardens in small areas.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Plants that produce limited debris")]), _vm._v(" each year are essential in town gardens, where the disposal of garden waste can be a problem.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Plants that do not encourage the presence of pests and diseases")]), _vm._v(" are desirable. Some plants attract pests and diseases and these should be avoided.")])]), _vm._v(" "), _c('div', {
    staticClass: "red-yel"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("CONIFER CONFLICT!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Do not plant the fast-growing, hedging conifer")]), _vm._v(" Cupressocyparis leylandii ("), _c('em', [_vm._v("Leyland Cypress")]), _vm._v(") "), _c('em', [_vm._v("in your garden. Within ten years it will need to be removed.")])])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("AVOIDING BAMBOO BLUNDERS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Bamboos are superb garden plants, creating interest throughout the year with their colorful leaves and canes. Some have invasive roots, however; here are ways around the problem.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Select problem-free bamboos")]), _vm._v(" (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 50")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Plant suitable bamboos in containers")]), _vm._v(" (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 50")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Install bamboo barriers")]), _vm._v(" (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 50")]), _vm._v(").")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("PICTORIAL SURVEY OF PLANTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small gardens can be just as colorful and exciting as large ones. Indeed, when a color-packed small garden is compared with the same area in a large garden it is often more attractive. Success is a matter of "), _c('em', [_c('strong', [_vm._v("concentrated gardening endeavor")])]), _vm._v(" and "), _c('strong', [_c('em', [_vm._v("selecting the right plants.")])]), _vm._v(" This fully illustrated book will help you create such an exciting garden.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0007-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0007-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0007-01"
    }
  }), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0007-01"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec4"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0007-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Choice of infrastructure")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("hen planning the infrastructure of a small garden, there is usually more money available for the construction of each square yard or meter than for a large garden, where economies generally have to be made. Additionally, because the area is small, immediate and more distinctive visual impact is needed. Garden centers and builder’s yards, as well as catalogs from magazines and newspapers, will give you an idea of the materials available.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Are special designs possible?")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("FENCING CHECKS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("You may have inherited an attractive small garden and initially decided not to make radical changes, but if you have children and dogs it is worth checking fences.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Fencing posts broken at ground level can be repaired by cutting off the base and fitting a spike-ended, metal, post-base. Alternatively, bolt a concrete or wooden post to sound wood and re-concrete into the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" A wide variety of materials and styles are available for fencing. For a more formal setting, use cast iron. For a casual, Western look, choose split rail fencing. If the fence is more than just decorative, as in keeping in pets, opt for appropriately sized fencing.")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0008-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0008-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0008-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Walls smothered in flowering climbers, such as Roses, Clematis and Honeysuckle, create color as well as informality.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0008-01"
    }
  }), _c('div', {
    staticClass: "boxb"
  }, [_c('a', {
    attrs: {
      "id": "imgf0008-01"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Structural elements to consider")])]), _c('p', {
    staticClass: "bullets"
  }, [_c('a', {
    attrs: {
      "id": "imgf0008-01"
    }
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Decking:")]), _vm._v(" raised or at ground level – ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 69")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Edgings:")]), _vm._v(" wide range, including concrete and wood – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 75")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Paths:")]), _vm._v(" surfaces and durability – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Patios, courtyards and terraces:")]), _vm._v(" wide choice – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 64")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Pergolas, trellises and arches:")]), _vm._v(" for small gardens – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Porches and entrances:")]), _vm._v(" decorative features – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 74")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Sheds and greenhouses:")]), _vm._v(" practical features – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Steps:")]), _vm._v(" practical yet attractive – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 68")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bulls"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Walls and fences:")]), _vm._v(" garden perimeters – "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("PROBLEMS WITH CLAY")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Increasingly, high temperatures combined with limited summer rain causes clay to shrink radically. Where foundations of buildings are deep, this creates few problems but, when paving slabs on a patio or path have only a thin concrete base, eventually they deform and buckle. First-aid treatment is to lift and re-cement individual slabs. For a longer-term solution, you will need to lift all the slabs and provide a thicker base for the complete patio or path.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("DISPOSING OF RUBBISH")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There are several solutions for disposal:")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _c('strong', [_vm._v("Rent a rollaway bin")]), _vm._v(" – check that the company is insured, that they know about your city’s codes about placement of the rollaway, and that the size they deliver is appropriate for your needs.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Builder’s bags")]), _vm._v(" – these are increasingly used to deliver building materials, as well as collecting rubbish. They are about a yard/meter square and deep. Check with your local builder’s merchant.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _c('strong', [_vm._v("Local authority")]), _vm._v(" – may provide a trash-collection service.")]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_vm._v("INFRASTRUCTURE EXAMPLES")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("A small garden")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0009-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0009-01"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("Within informal gardens, a surprisingly wide range of features can be included in a casual yet purposeful manner. The pergola acts as a focal point.")])])]), _c('a', {
    attrs: {
      "id": "imgf0009-01"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("A small front garden")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0009-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0009-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0009-02"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("Most small front gardens have a formal character, with plants in rows and neat roadside edgings. Porches help to create focal points for paths.")])])]), _c('a', {
    attrs: {
      "id": "imgf0009-02"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("A small courtyard")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0009-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("Courtyards are summer-leisure areas as well as places where plants can be grown. By their nature, courtyards are private areas, with complete seclusion.")])])]), _c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("THINK ABOUT THE PLANTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Don’t separate the selection of plants from getting the infrastructure right.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("If you like relaxed plants such as bamboos, ferns and ornamental grasses, you will want an informal garden to complement them.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" For clinical and regimented displays of summer-flowering bedding plants, you will need a formal garden.")]), _vm._v(" "), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("INFRASTRUCTURE FOR ROOF GARDENS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Persistent and buffeting wind combined with strong sunlight make roof gardens difficult but exciting places for gardening. Additionally, consider the following constructional questions.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Permission may be required from the building’s owner, as well as from local authorities. Also, check the thoughts of neighbors – it may not impress them.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" The weight of the flooring needs to be light but strong – check with a structural engineer if in doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" The weight of pots and other containers – when full of soil and after being watered – may be excessive.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Don’t damage felt roofs.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Make sure excess water is adequately drained.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" A sturdy screen is usually needed to filter strong wind. Make sure it cannot be blown away and cause damage to people and property.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("MAKING THE MOST OF BALCONIES")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("These are more sheltered than a roof garden, and with a base that is firm and secure. However, a sun-facing position will rapidly dry compost.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" If the balcony does not have a roof, fit a collapsible sunshade.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Where a balcony has a roof, but strong, late-evening sunlight still causes dazzle, you can fit a sun shade to the balcony’s upper edge.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Always make sure that water cannot drip on people or balconies below. Wherever possible, stand pots in large, plastic saucers.")])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec5"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0009-03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Problems and opportunities")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("ith all sites there are problems and opportunities, and sometimes areas that initially appear totally inhospitable eventually produce the most interesting and distinctive gardens – unique and full of character. Creating height through arches, trellises and pergolas draws attention away from exceptionally narrow or short gardens, while a levelled area on a steep slope becomes idyllic when turned into a leisure feature, especially if illuminated at night.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Can all sites be made attractive?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0010-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0010-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Use climbers to cloak eyesores and barren walls. Hanging baskets and window boxes can be used in a similar way.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0010-01"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0010-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0010-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0010-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Annuals are sown in spring each year to create an inexpensive yet vibrantly colored feast of flowers.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0010-02"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0010-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0010-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0010-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Raised decking is ideal for creating a distinctive feature, perhaps alongside a stream or a colorful garden pond.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0010-03"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("TOO SMALL?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Logically, there is a size when it is near impossible to create an area in which plants can be grown. Yet many successful gardens are created in areas at the entrances to basement apartments, where both space and light are limited. In small areas ideals are limited, but a few decorative pots, a hanging basket and window box can be just as cherished as an extensive and well-manicured lawn is to a croquet devotee.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("SEEING THE OPPORTUNITIES")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The ability to recognize hidden opportunities in potential gardens is, in part, gained by looking at other gardens, both locally and nationally. Some large display gardens even have areas where a range of small gardens are featured; even if one of them in its entirety does not suit you, an amalgam of several elements may be practical in your garden. Have a sketch-pad or camera handy and take a few notes that later give clues to opportunities.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("LEGACY PROBLEMS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Often there are existing structures in a garden left from the previous owners (or even before them). It could be poles set in concrete to hang out the wash, or the foundation of an old shed. Regardless, former owners often let these existing obstacles restrict their garden design. When first taking possession of a new garden, the time is now to remove these old structures so you can start from a clean slate.")])]), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-03"
    }
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("SHADY OR SUNNY?")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "imgf0010-03"
    }
  }, [_c('em', [_vm._v("A garden’s aspect is not usually the first consideration when moving to a new house. Whether it is fully exposed to sunlight or shaded by trees or neighboring buildings can be a lottery that brings both problems and opportunities. There are plants that delight in full sun, while others prefer to grow in shade. The light or shade preferences of many plants are detailed in the plant directory (see ")])]), _c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("The degree and nature of light and shade in a garden varies from one part of a day to another.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Full sun:")]), _vm._v(" many plants thrive in full sun, especially if regularly watered. Those native to hot countries and with hot-climate adaptations such as silvery, hairy or aromatic leaves are first choices, but even these need help when getting established. Regular watering and yearly mulching are two moisture-saving tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Light shade:")]), _vm._v(" most plants thrive in a combination of dappled light and full sun. Unless there is a large, overhead canopy of leaves from a tree (which also deprives other plants of moisture and nutrients) the brightest time is during the middle part of a day.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Heavy shade:")]), _vm._v(" most decorative garden plants do not grow well or exhibit attractive qualities when in deep shade. Unless the shade comes from a building, thin out an overhead canopy created by trees.")])]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('strong', [_vm._v("AWKWARDLY SHAPED SITES")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Long and narrow")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0011-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0011-01"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("Create the impression of a shorter garden by dividing it into several units, each with a unique feel. In a small garden, a free-standing trellis, perhaps combined with a leaf-drenched arch, takes up less space than a dense hedge. Create mystery by varying the position of a linking path, making it impossible to see the back of the garden from the house.")])])]), _c('a', {
    attrs: {
      "id": "imgf0011-01"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Short and wide")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0011-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0011-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0011-02"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_vm._v("Accentuate the shortness by erecting a head-high screen of leafy or flowering climbers across the garden, so that the boundary cannot be seen. Ensure that the screen is not too high, because a glimpse of openness beyond the garden removes any feeling of claustrophobia. A well-kept lawn creates an impression of space, while a bench positioned close to the screen forms a focal point.")])])]), _c('a', {
    attrs: {
      "id": "imgf0011-02"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Steep slopes")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0011-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0011-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0011-03"
    }
  }, [_c('p', {
    staticClass: "captiona1"
  }, [_vm._v("Slopes provide added interest in a garden, although moving from one level to another can sometimes be difficult – especially as age progresses. Flights of 6–8 steps – with a resting landing between them – make slopes easier to negotiate.")]), _vm._v(" "), _c('p', {
    staticClass: "captioni"
  }, [_vm._v("Creating a flattened leisure area on a steep slope helps to split it up. Where possible, position this feature level with head height when viewed from a patio around the house.")])])]), _c('a', {
    attrs: {
      "id": "imgf0011-03"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Terracing slopes")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Brick retaining walls have a formal nature and are suited to relatively open areas, whereas old railroad ties are better for relaxed and informal settings with beds of grasses and deciduous azaleas. Peat-blocks are another solution to soil retention, but not on steep slopes. In open areas, slopes can be grass, with level areas interspersed with 45° slopes. Powered edge trimmers are ideal for cutting grass on slopes.")])])]), _c('a', {
    attrs: {
      "id": "imgf0011-03"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("SOIL PROBLEMS")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "imgf0011-03"
    }
  }, [_vm._v("Soils vary in their nature; most are neutral and neither acid nor alkaline. Others are well drained, some waterlogged. Occasionally they are hot and dry. Plants that prefer specific soils are indicated in the plant directory (see ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Acid soils:")]), _vm._v(" these are soils with a pH below about 6.5. Acidity can be corrected by dusting the surface with hydrated lime or ground limestone in winter, after digging. However, some plants – such as Rhododendrons and Azaleas – demand acid soils.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Alkaline (chalky) soils:")]), _vm._v(" these have a pH above 7.0. Chalky soils can be corrected by used acidic fertilizers such as sulphate of ammonia, plus applications of peat. Many plants grow well in chalky soils.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Neutral soils:")]), _vm._v(" these are soils with a pH of 7.0, although most plants grow well in a pH between 6.5 and 7.0.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Exposed and windswept sites")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Newly planted as well as established plants are often damaged by cold, searing winds. Hedges filter the wind and can be used to make gardens more congenial for tender plants. Walls create barriers and encourage swirling eddies on the lee side, as well as buffeting on the windward face.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Coastal gardens")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Salt-laden wind is present along coastal strips as well as a few miles or kilometers inland. Some plants tolerate these conditions, while others have their leaves damaged. Coastal plants for forming attractive hedges in warm areas include "), _c('em', [_vm._v("Fuchsia magellanica")]), _vm._v(" (Hardy Fuchsia) and "), _c('em', [_vm._v("Tamarix ramosissima")]), _vm._v(" (Tamarisk; also known as "), _c('em', [_vm._v("Tamarix pentandra")]), _vm._v(").")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Design and planning")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("F")]), _vm._v("or many people, gardens just evolve or are a continuation of one that was inherited during a change of house ownership. When starting from scratch, however, a plan is essential for the major infrastructure including, if desired, the size, shape and position of a lawn. Pencilling in positions and sizes of shrubs and trees also helps to generate thoughts of specific plants. See the plant directory ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") for guidance on choosing plants for small gardens.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Is detailed planning essential?")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("ASSESSING SLOPES")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Differences in levels are difficult to judge without specialized equipment. Home gardeners, however, can use a hose to assess a slope. Tie one end to a post inserted at the highest position. Trail the other end to the lower position and raise it (attached to a post) to about the same height. Fill the hose with water until both ends are full; a piece of clear plastic tubing in each end makes this easier to judge. The height of the water at either end of the hose will be the same, allowing you to judge differences in ground height.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("MAPPING OUT THE AREA")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("If the area has a regular shape, transfer the garden’s size and shape directly to graph paper. For irregular outlines, use a hose. Use a hose to outline an irregular shape. Use string between two stakes to create a center line for the irregular shape. Measure from the center line to the house at regular intervals and transfer the measurements to graph paper.")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0012-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0012-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0012-01"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Create a detailed and precise plan on graph paper")])])])]), _c('a', {
    attrs: {
      "id": "imgf0012-01"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("MARKING IN YOUR DESIGN")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When the shape and size of the garden have been marked on graph paper, it is possible to transfer your desired features (see above right) onto the plan. First, photocopy the graph paper several times so that different sketches can be made.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Gathering inspirations")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("All members of a family believe themselves to be supremely gifted when choosing garden features. Family involvement is essential, however, and, if everyone notes their preferences, a sensible list of priorities can be created.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_vm._v("When planning a family garden, remember that within several years a play area for children will not be needed. Therefore, initially shape such an area so that another feature, perhaps a garden pond or alpine garden, can be later slotted into its place.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Storm water")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("As global warming increases, redirecting surface water from heavy rainstorms will be necessary. Essentially, water needs to be directed away from houses and their foundations. Wherever possible, install drains or enable water to seep into soil, rather than running off paved areas and directly up to a house, where it can enter through air ventilation bricks and doors.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("FAUCETS, WATER VALVES AND DRAINS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Mark water valves and manhole-covers on the plan. A water valve for a water main is usually positioned just inside your property’s boundary and next to a sidewalk or road. These cannot be moved. Sewer covers also cannot be moved, but their covers can be raised and merged into a drive or standing area for cars. This is usually a job for a builder.")])]), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0012-01"
    }
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("PLANNING CHECKLIST")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('strong', [_vm._v("DO:")])]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick.jpg"
    }
  })]), _vm._v(" Do choose small and slow-growing shrubs and trees for small gardens. Excessively pruning large shrubs and trees, with a view to keeping them small, does not work.")])]), _c('p', {
    staticClass: "tick"
  }, [_c('a', {
    attrs: {
      "id": "imgf0012-01"
    }
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick.jpg"
    }
  })]), _vm._v(" Do create a garden that is unique to you – a wide range of opportunities are described on ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_4"
    }
  }, [_vm._v("here")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick.jpg"
    }
  })]), _vm._v(" Do consider space-saving wall-trained fruit trees for small gardens. Fruit can also be grown in large containers on a patio (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick.jpg"
    }
  })]), _vm._v(" Do install garden lighting as it extends the period of outdoor-living during summer (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#page_14"
    }
  }, [_vm._v("page 14")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("DON’T:")])]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick1.jpg"
    }
  })]), _vm._v(" Don’t plant hedges less than half their expected width next to a boundary.")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick1.jpg"
    }
  })]), _vm._v(" Don’t plant trees with spreading branches close to a boundary. Your neighbor may be entitled to cut them off, spoiling the tree’s shape.")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick1.jpg"
    }
  })]), _vm._v(" Don’t plant invasive bamboos near to a boundary (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 50")]), _vm._v(" for non-invasive types).")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick1.jpg"
    }
  })]), _vm._v(" Don’t drain water so that it runs on to neighboring gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "tick"
  }, [_c('span', {
    staticClass: "ti"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/tick1.jpg"
    }
  })]), _vm._v(" Don’t position patios and terraces directly on boundary lines as it may then be impossible to erect a fence or trellis.")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Getting equipped")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("ell-made garden tools that suit your height and build are an investment for life and a pleasure to use. Always buy the best quality that you can afford; stainless-steel types are expensive and durable, but others – perhaps with an anodized surface – are just as long-lived if they are regularly cleaned after use and stored in a dry, well-ventilated shed. Garden spades and forks are both available in several sizes, and with a choice of handle types.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Are garden tools expensive?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "w-blue"
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("BASIC GARDENING TOOLS")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Digging and soil preparation")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-01"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Spade")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-01"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-02"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Fork")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-02"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-03"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Rake")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-03"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-04"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Hoe")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-04"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-04"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-04"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-05"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Trowel")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-05"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-05"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-05"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-06"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-06.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-06"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Hand fork")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-06"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-06"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-06"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-07"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-07.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-07"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Wheelbarrow")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-07"
    }
  }, [_c('p', {
    staticClass: "paras1"
  }, [_vm._v("Garden spades and forks are mainly used to dig soil, while rakes are for levelling. Dutch hoes cut weeds just below the soil surface and create a friable surface, and draw hoes form furrows, as well as hoeing and removing weeds.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Watering the garden")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("A stout watering can is essential for watering trays of young plants before they are planted outside – as well as for watering them regularly afterwards. On a large scale, using a hose and sprinkler will make it much easier to care for plants.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-07"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-07"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-08"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-08.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-08"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Watering can")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Lawn tools")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-08"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-08"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-09.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Lawn rake")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-09"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-10.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-10"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Edging shears")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-10"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-10"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-10"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-11.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-11"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Edging knife")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-11"
    }
  }, [_c('p', {
    staticClass: "paras1"
  }, [_vm._v("Spring-, plastic- and rubber-tined lawn rakes are ideal for removing dead grass and leaves, and scattering worm-casts. Edging knives are used to neaten lawn edges, and edging shears are for trimming long grass at the edges.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Pruning and hedging tools")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-11"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-11"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-12.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-12"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Hand shears")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-12"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-12"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-12"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-13"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Loppers")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-13"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-13"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-13"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-14"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-14.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-14"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Hedging shears")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-14"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-14"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-14"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-15.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-15"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Pruning saw")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-15"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-15"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-15"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0013-16.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Electric hedge trimmers")])])])]), _c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }, [_c('p', {
    staticClass: "paras1"
  }, [_vm._v("Hand shears, both “bypass” and “anvil” types, are used for pruning, as are pruning saws and loppers. Hedge trimmers are ideal for trimming hedges; electrical ones are best for large hedges.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Greenhouses")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("In greenhouses, pots and seed-trays are essential, together with dibbles and knives for trimming cuttings. Long-spout watering cans are useful.")])])]), _c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("WHEN BUYING GARDEN TOOLS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When buying a garden tool, always check its weight and feel the way it handles. Unless it feels right, leave it alone. Left-handed pruning shears are available, and these make pruning much easier for left-handed gardeners.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("SAFETY FIRST")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Garden tools can be lethal to other people, as well as yourself. When using them, make sure they cannot be tripped over or, in the case of a metal rake, trodden on and quickly knocked upright.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("CLEANING AND STORING")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Washing and cleaning garden equipment after use extends its life. Dry bright metal surfaces and wipe them with an oily rag. Clean and dry wooden and plastic handles. When not in use, store tools in a dry, well-aerated shed – preferably, hang them up.")]), _vm._v(" "), _c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Garden spades")]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Garden spades are the most widely used pieces of garden equipment and their range is wide. Spades are available in several sizes: digging types have blades about 11 x 7½ in (27 x 19 cm), while border models are 9 x 5½ in (23 x 14 cm) and often sold as “lady’s spades.” Some spades have blades with tread-like ledges at the top of the blade, enabling more pressure to be put on the blade while digging, but this makes them more difficult to clean.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_vm._v("Most spades have a 28 in (72 cm) long handle, although others are 32 in (82 cm). There are three different types of handle, and the one to choose is a matter of personal preference. These include T-shaped, D-handle, and a straight shaft (which is the most popular).")])])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec8"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0013-16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Lighting in a garden")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("G")]), _vm._v("arden illumination – whether on patios, in borders, among trees or around ornamental ponds as well as submerged – has gained in popularity, and in return for the initial cost and subsequent maintenance makes a garden and patio more attractive and usable over a longer period each day. Additionally, autumn-colored deciduous trees and frost-covered stems during winter can be highlighted. For barbecue enthusiasts, patio lighting is essential.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Are garden lights worth installing?")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("ON PATIOS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The edges of patios and terraces can be transformed by low spotlights as well as column types. Also, where a table is present a light that illuminates it is useful for late-evening relaxation. Avoid having cables suspended randomly over a patio.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("IN BORDERS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Throughout summer and into autumn, borders of all types – packed solely with herbaceous perennials or a medley of types – benefit from illumination. Flowers and colored leaves can be given added qualities by lights positioned looking down on plants. Additionally, a few lights within a border create attractive shadows.")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0014-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Ornamental lights are ideal for patios and terraces.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }), _c('div', {
    staticClass: "w-blue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }, [_c('h3', {
    staticClass: "h3b-blue"
  }, [_c('strong', [_vm._v("TYPES OF LIGHTING")])]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("The quality and intensity of light is influenced by the source of power – household power, battery or solar.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Household power:")]), _vm._v(" this creates the strongest and most penetrating light and is suitable for large installations and powerful spotlights. It also requires the most careful and thorough installation.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Battery power:")]), _vm._v(" the size and quality of the battery determines the power of the light, which slowly diminishes as the battery becomes exhausted. Nevertheless, it is a safe way to have light on a patio or terrace.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Solar power:")]), _vm._v(" the penetrative quality of the light is poor, but is useful for highlighting the edges of features, from patios to paths and around ponds. It has the bonus of being powered by the sun and inexpensive to operate.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0014-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0014-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0014-02"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Spotlights are ideal for highlighting specific plants, as well as on patios during summer evenings")])])])]), _c('a', {
    attrs: {
      "id": "imgf0014-02"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0014-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0014-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0014-03"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Low-intensity lights on short, supporting stems are good for positioning around either a patio or a garden pond")])])])]), _c('a', {
    attrs: {
      "id": "imgf0014-03"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0014-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Lantern-type battery lights, with their ornamental appearance, are useful for hanging from trees around a patio")])])])]), _c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("AROUND PONDS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Whether a garden pond is integrated with a patio or featured in a lawn setting, it will be enhanced by a few strategically placed lights. If a waterfall or cascade feeds water into it, these too can be illuminated. Fountains, with their wide and varying range of spray patterns, are also enhanced.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("IN PONDS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Submerged lighting – sometimes colored in red, green, amber or blue – adds a fresh and often novel quality to ornamental ponds. Some lighting equipment creates a rainbow of changing light. Ensure that the equipment is safely installed.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("FLOODLIGHTING TREES AND SHRUBS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Wall- and post-mounted lights create light over a large area, while low-powered colored lights in a continuous line of up to 40 lamps are possible for stringing between trees. For many gardens, however, a few white spotlights focused upwards and into branches have more appeal.")]), _vm._v(" "), _c('div', {
    staticClass: "red-yel"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("SAFETY FIRST")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Electricity and water are not happy partners and all electrical installations need to be checked over or installed by a competent electrician. Where voltage is reduced through a transformer the risk to yourself and family is less than when the power comes directly from the household power supply.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_vm._v("DO NOT TAKE ANY RISKS – THINK SAFETY FIRST WITH ELECTRICITY AT ALL TIMES.")])])])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec9"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0014-04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Choosing and buying plants")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("P")]), _vm._v("lants can be bought throughout the year and planted whenever the soil and weather allow (see below for times to buy plants). However, for most gardeners spring is the time when thoughts of planting a new border or restructuring a garden are implemented. This timing enables plants to become established before the onset of unfavorable weather in autumn. However, bare-rooted shrubs and trees need to be planted in very late winter or early spring.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("When should I buy plants?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "blue-sblue"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("WHERE TO BUY PLANTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Always buy plants – whether shrubs and trees, herbaceous perennials or bulbs and bedding plants – from reputable sources. You will want to be assured that the plant is correctly labelled as well as healthy.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Garden centers:")]), _vm._v(" these mainly sell container-grown plants, and therefore it is essential to visit them in a car, although some offer a local delivery service. Check out the garden center as well as plants; if it looks neglected and radiates little pride, this may be reflected in the quality of the plants.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Nurseries:")]), _vm._v(" these offer bare-rooted as well as container-grown plants. Container-grown types are available throughout the year, and bare-rooted ones in late winter and early spring only. They can either be collected, or arrangements made for delivery. Some nurseries specialize in specific plants, and this may mean a long journey or buying through a catalog.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Local shops and markets:")]), _vm._v(" a wide range of plants is offered, from container-grown shrubs and herbaceous perennials to biennials and bulbs. Remember, however, to check the plants thoroughly before buying.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("Mail order:")]), _vm._v(" Many plants, including bare-rooted shrubs, trees and roses, and container-grown shrubs can be bought through mail-order sources. Orders can be given by telephone, website, fax or post, and paid for by check or credit cards. Most mail-order companies are reputable, but don’t forget that you will be buying plants unseen.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("WHAT TO LOOK FOR WHEN BUYING SHRUBS AND TREES")]), _vm._v(" "), _c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Container-grown")]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0015-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0015-01"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Check that there is no moss on the soil, or masses of roots coming out of the drainage holes in the container.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0015-01"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Bare-rooted")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0015-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0015-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0015-02"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Check that the roots are undamaged. Usually, the roots are covered to prevent them becoming dry. Always buy such plants from a reputable source.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0015-02"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Balled")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0015-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0015-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0015-03"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Roots are tightly wrapped in burlap. Check that this is not loose and compost has not fallen away. It should be lightly moist.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0015-03"
    }
  }, [_c('h3', {
    staticClass: "h3s1"
  }, [_vm._v("Wrapped in plastic")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0015-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0015-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0015-04"
    }
  }, [_c('p', {
    staticClass: "captiona"
  }, [_c('em', [_vm._v("Stems and shoots are healthy, with moisture-retentive material around roots. Remove packaging as soon as possible.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0015-04"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("TIME OF THE YEAR TO BUY")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Container-grown shrubs, trees, climbers and wall shrubs are sold throughout most of the year.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Bare-rooted shrubs, trees and wall shrubs are sold and planted during late winter and early spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" “Balled” evergreen shrubs and conifers are sold and planted in late summer and early autumn, or in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Herbaceous plants are mainly sold in early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Summer-flowering bedding plants are sold in late spring and early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Rock-garden plants are usually sold in containers in spring or early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Spring-flowering bulbs are sold in late summer or early autumn, for immediate planting.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Spring- and early summer-flowering biennials are sold in early autumn, for immediate planting.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Water-garden plants are usually sold in early summer.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("GETTING PLANTS HOME")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A car is usually essential. For safe arrival home with plants, do not take children or dogs with you! Make a special visit to buy plants, rather than squeezing them in between other shopping. Cover seats with plastic sheeting.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("WHEN PLANTING IS DELAYED")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bare-rooted shrubs and trees can be “heeled-in” if soil and weather are not suitable for immediate planting.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Select a sheltered position with moderately moist soil.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Dig a trench 12–15 in (30–38 cm) deep, with a sloping side away from prevailing wind.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Remove packaging and position the roots in the trench.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Spread friable soil over the roots and slightly firm it; lightly water if dry.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Plants can be left for several weeks, until soil and weather are suitable for planting.")])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-04"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec10"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0015-04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("Looking after plants")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("P")]), _vm._v("lants need careful attention throughout their lives. Summer-flowering bedding plants in containers on a patio need regular watering and removal of dead flowers, while lawns require cutting and edges trimmed; also, trees must be checked to ensure stakes are not rubbing their bark. The gardening year is full of plant maintenance that turns a mediocre garden into one in which you can be especially proud. These pages show how to look after a wide range of plants.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Do plants need regular attention?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "nobreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0016-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Summer-flowering plants in hanging baskets, window boxes, troughs and tubs need watering each day, especially when the weather is hot.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }), _c('div', {
    staticClass: "boxo1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Plants in containers")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0016-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0016-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0016-02"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("In winter, prevent soil in tubs and large pots becoming too wet by covering with plastic")])])])]), _c('a', {
    attrs: {
      "id": "imgf0016-02"
    }
  }, [_c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Water plants regularly throughout summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Pinch off growing tips of some summer-flowering plants to encourage bushiness.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Remove dead flowers to encourage others to develop.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Regularly feed plants in hanging baskets, window boxes, wall baskets and tubs.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In winter, cover soil in tubs and large pots which are homes to shrubs and trees to prevent it becoming excessively wet.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0016-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("In winter, cloak tender shrubs in large containers with straw")])])])]), _c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("DO ALL PLANTS NEED LOOKING AFTER?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most garden plants are in an artificial environment, often radically different from their native areas. However, the majority of them are adaptive and grow surprisingly well in alien conditions – but they do benefit from extra care and attention, especially when young and becoming established.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Plants are often expected to create colorful displays year after year, while others are encouraged to put all of their endeavors into a feast of color during a few summer months.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("LOW MAINTENANCE?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Trees, shrubs and conifers need less attention than summer-flowering bedding plants in borders or those planted in containers on a patio, such as hanging baskets, wall baskets and window boxes. Unless these are regularly watered, displays soon fail.")]), _vm._v(" "), _c('div', {
    staticClass: "violet"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after hedges")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Keep the bases of young hedges weed-free – they rob plants of moisture and food.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Refirm soil around young hedges in spring – use the heel of your shoe.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Water young hedges to encourage rapid establishment.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Regularly trim formal hedges to create a neat shape.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Brush off snow as soon as possible; use a bamboo cane or a soft brush. If left, the weight of snow deforms hedges.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Use pruning shears – rather than hedge trimmers – to shape and remove straggly shoots from large-leaved, informal hedges. Take care not to shred leaves.")])])]), _c('div', {
    staticClass: "boxg1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after a lawn")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Regularly water lawns – especially newly established ones – throughout summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Cut lawns throughout summer. During dry, hot summers leave the grass longer and cut less frequently.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Trim lawn edges to keep the lawn neat. Pick up the cut edgings.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Rake and scarify lawns. Additionally, in autumn rake off fallen leaves from nearby trees.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Aerate and topdress lawns during late summer or early autumn.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0016-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Use edging shears to trim long grass along lawn edges")])])])]), _c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  }), _c('div', {
    staticClass: "boxg1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  }), _c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "imgf0016-04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("Repairing holes in lawns")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" Place a piece of wood, 10–12 in (25–30 cm) square and ½ in (12 mm) thick, over the hole; use an edging iron to cut around it.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("2")])]), _vm._v(" Lift out the piece of turf and level the soil.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("3")])]), _vm._v(" Use the same piece of wood to cut a square of turf from an out-of-the-way position.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("4")])]), _vm._v(" Place the fresh piece of turf in the hole (above, right) and sprinkle friable soil along the joints. Firm and water the area.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0017-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0017-01"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0017-01"
    }
  }, [_c('div', {
    staticClass: "boxg1"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Repairing lawn edges")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" Place a 8–9 in (20–23 cm) wide and 12 in (30 cm) long, ½ in (12 mm) thick piece of wood over the damaged area.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("2")])]), _vm._v(" Use an edging knife to cut around it.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("3")])]), _vm._v(" Lift out the tuft and turn it so that the damaged area is towards the lawn’s middle.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("4")])]), _vm._v(" Sprinkle friable soil into the damaged area, firm and dust with lawn seed; gently water.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg1"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Levelling bumps and depressions in lawns")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" Use an edging knife to cut a straight line across the bump or depression.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("2")])]), _vm._v(" Then, use the edging knife to cut several lines, 9 in (23 cm) apart, at right angles to the first line.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("3")])]), _vm._v(" Peel back the turf and either add or remove soil.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("4")])]), _vm._v(" Replace the turf, firm and dribble friable soil into the cuts. Water.")])])]), _c('div', {
    staticClass: "boxo1"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-01"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Cutting off a large branch")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("1")])]), _vm._v(" Cut one-third of the way through the branch from the bottom about 2 in (5 cm) from the branch collar on the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("2")])]), _vm._v(" About 1 in (2.5 cm) further out, cut off the branch.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "num"
  }, [_c('strong', [_vm._v("3")])]), _vm._v(" Cut the remaining stub off just outside the branch collar of the tree..")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0017-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  }, [_c('div', {
    staticClass: "boxb"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after a pond")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Keep the water topped up throughout summer. Evaporation soon lowers the water’s surface and may damage plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" If ponds need to be emptied and cleaned, choose a warm day in early summer – but first remove the fish.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In autumn, remove leaves that have fallen into the pond. Also, pull out dead leaves from water plants.")])]), _vm._v(" "), _c('div', {
    staticClass: "violet"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after herbaceous plants")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In late autumn or early spring, remove dead stems and supporting, twiggy sticks (if used).")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In spring, lightly fork the soil. Water the soil and add a mulch. Additionally, some plants need support.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Throughout summer, remove dead flowers. Keep the soil moist, especially during hot weather.")])]), _vm._v(" "), _c('div', {
    staticClass: "violet"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after annual bedding plants")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" These are planted in early summer (after all risk of frost has passed); keep the soil moist, especially during hot weather.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In mid-summer, scatter a general fertilizer around plants (but not touching) and gently water the soil.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In autumn, pull up all plants and place on a compost heap.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxo1"
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after shrubs")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Plant them in early autumn, as soon as available. Sometimes this is combined with planting bulbs between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Thoroughly water the soil to ensure that plants do not shrivel in hot autumn sunshine.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In early spring, refirm frost-loosened soil around plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Pull up and discard plants when their displays finish.")])])]), _c('div', {
    staticClass: "box-g"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Looking after shrubs")]), _vm._v(" "), _c('p', {
    staticClass: "bullets"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" In spring, lightly fork soil around established shrubs. Thoroughly water and add a 3–4 in (7.5–10 cm) thick mulch.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" During hot summers, regularly and thoroughly water the soil, especially for shrubs in flower.")]), _vm._v(" "), _c('p', {
    staticClass: "bullets1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v("Prune shrubs as required.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0017-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0017-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0017-03"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Shrubs such as this")]), _vm._v(" Buddleja davidii "), _c('em', [_vm._v("(Butterfly Bush) need yearly pruning")])])])]), _c('a', {
    attrs: {
      "id": "imgf0017-03"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-03"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0017-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0017-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0017-04"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Cut out “reverted” shoots from variegated evergreen shrubs")])])])]), _c('a', {
    attrs: {
      "id": "imgf0017-04"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-04"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-04"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0017-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  }, [_c('p', {
    staticClass: "captionc"
  }, [_c('em', [_vm._v("Most Roses need yearly pruning to encourage the regular development of shoots and flowers")])])])]), _c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  }), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  }), _c('h2', {
    staticClass: "chapa",
    attrs: {
      "id": "sec11"
    }
  }, [_c('a', {
    attrs: {
      "id": "imgf0017-05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Flower gardens")]), _vm._v(" "), _c('p', {
    staticClass: "parab"
  }, [_c('strong', [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("E")]), _vm._v("ven in small gardens it is possible to create a miniature, English-style flowering garden, with masses of color provided mainly by herbaceous plants with help from summer-flowering bedding plants. A wide range of herbaceous perennials is illustrated and discussed on "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(". They create superb displays for 3–4 years before needing to be lifted and divided, while summer-flowering bedding plants are planted fresh each year.")])]), _vm._v(" "), _c('div', {
    staticClass: "box-blue"
  }, [_c('p', {
    staticClass: "parac"
  }, [_c('strong', [_c('em', [_vm._v("Is a flood of color possible?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0018-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0018-01"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("INFORMAL MEDLEYS OF FLOWERING PLANTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Informal medleys of herbaceous perennials, summer-flowering bedding plants, shrubs, small trees, biennials and summer-flowering bulbs are especially popular in small gardens where, perhaps, only one border is possible. These “mixed” borders create color over a long period and often enable the inclusion of your most diverse and favorite plants. In a small garden, rely mainly on herbaceous perennials, with just a few shrubs that have a dual quality of flowers and colorful leaves. If some of these plants have fragrant flowers, that is a bonus.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-01"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0018-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0018-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0018-02"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Integrate garden ornaments into flower borders.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0018-02"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Where bulbs are used in mixed borders, choose mainly summer-flowering types, such as lilies. If spring-flowering bulbs are used, this prevents soil cultivation in early summer. Also, when their leaves have died down there is a risk of damaging the hidden bulbs.")])]), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-02"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-02"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0018-03"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0018-03.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0018-03"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("“Mixed” borders have a colorful and vibrant nature.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0018-03"
    }
  }), _c('div', {
    staticClass: "boxb"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-03"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Floral entrances with climbers and containers")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-03"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0018-04"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0018-04.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0018-04"
    }
  }, [_c('p', {
    staticClass: "paras"
  }, [_c('em', [_vm._v("English-style entrances become awash with color and fragrance from scented flowering climbers, with a variety of container-grown plants adding to the riot of color.")])]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("For formal entrances:")]), _vm._v(" large-flowered Clematis: wide range, with a deciduous nature and mainly single flowers, in many colors and often throughout summer.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("For semi-formal entrances:")]), _vm._v(" "), _c('em', [_vm._v("Clematis macropetala")]), _vm._v(": bushy and deciduous, with light and dark blue, bell-shaped and nodding flowers during late spring and early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "paras1"
  }, [_c('strong', [_vm._v("For rustic settings:")]), _vm._v(" "), _c('em', [_vm._v("Lonicera periclymenum")]), _vm._v(" (Woodbine/Honeysuckle): popular cottage-garden climber – the cultivar ‘Belgica’ (Early Dutch Honeysuckle) flowers during late spring and early summer, and ‘Serotina’ (Late Dutch Honeysuckle) from mid-summer to autumn.")])])]), _c('a', {
    attrs: {
      "id": "imgf0018-04"
    }
  }), _c('div', {
    staticClass: "nobreak"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-04"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-04"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0018-05"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0018-05.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0018-05"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Raised beds enable a variety of plants to be seen easily, as well as making gardening more comfortable for people who are confined to wheelchairs or who cannot easily bend down.")])])])]), _c('a', {
    attrs: {
      "id": "imgf0018-05"
    }
  }), _c('div', {
    staticClass: "w-blue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-05"
    }
  }), _c('h3', {
    staticClass: "h3b-blue"
  }, [_c('a', {
    attrs: {
      "id": "imgf0018-05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('strong', [_vm._v("HOW TO CREATE A MINIATURE FLOWER GARDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "paras"
  }, [_vm._v("Whatever a garden’s size, the desire to create masses of color is paramount, as well as replicating a traditional English-style flower garden with its homely and reassuring nature. In earlier years and on a grand scale, borders were sometimes color-themed – perhaps mainly white, gold-and-yellow, green or blue – now this is seldom attempted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paras"
  }, [_vm._v("Traditionally, herbaceous perennials were grown in double borders, facing each other, separated by a broad grass path and backed by hedges that created shelter and harmonized with color-themed borders. Nowadays, and on a small scale, this can be replicated by creating borders with small-garden herbaceous perennials (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), a central path and two small lawns on either side of it. Path edgings of summer-flowering bedding plants can be used to introduce further color.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-paras"
  }, [_vm._v("Adding a paved or bricked surface at the far end of these borders and lawns creates a focal point, as well as a leisure area for an attractive bench.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0019-01"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0019-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0019-01"
    }
  })]), _c('a', {
    attrs: {
      "id": "imgf0019-01"
    }
  }, [_c('div', {
    staticClass: "blue-sblue"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("RANGE OF PLANTS")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', [_vm._v("Using a wide range of plants creates greater interest.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Hardy annuals:")]), _vm._v(" these are sown in their flowering position outdoors in spring; they die in autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Half-hardy annuals:")]), _vm._v(" these are sown in gentle warmth in late winter or early spring and planted in early summer; they die in autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Herbaceous perennials:")]), _vm._v(" these grow and flower for 3–4 years before being lifted and divided. Each year, plants die down to ground level in autumn and develop fresh shoots in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Bulbs, corms and tubers:")]), _vm._v(" there is a wide range of types, but all are powerhouses of stored energy. Some flower in winter or spring, others in summer or autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Climbers:")]), _vm._v(" a few of these are hardy annuals, while others are perennial and will grow happily from one year to another with very little attention.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Shrubs:")]), _vm._v(" these are woody-natured, with several stems growing from ground level. Most live for ten years or more. They can be deciduous or evergreen.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet1"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" "), _c('strong', [_vm._v("Small trees:")]), _vm._v(" these are woody-natured, with a single stem (trunk) connecting the branches to the roots. Most live for 20 or more years, and they can be deciduous or evergreen.")])])]), _c('div', {
    staticClass: "boxb"
  }, [_c('a', {
    attrs: {
      "id": "imgf0019-01"
    }
  }, [_c('h3', {
    staticClass: "h3c"
  }, [_vm._v("Honeysuckle arbor")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "imgf0019-01"
    }
  }), _c('a', {
    attrs: {
      "id": "imgf0019-02"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/f0019-02.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "imgf0019-02"
    }
  }, [_c('p', {
    staticClass: "paras"
  }, [_vm._v("As well as clothing porches and rustic arches alongside boundary hedges and over garden paths, consider creating a Honeysuckle-covered arbor in a secluded part of your garden. Such a feature has a relaxed character and is best used in an informal setting. Choose a semi-rustic bench.")])])]), _c('a', {
    attrs: {
      "id": "imgf0019-02"
    }
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("INITIAL COST")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" With shrubs, the initial cost is high, but remember that this will be spread over ten years or more.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Herbaceous perennials are less expensive than shrubs, and they can be lifted and divided after 3–4 years before being replanted, thus creating more plants for free.")]), _vm._v(" "), _c('p', {
    staticClass: "bullet"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Summer-flowering bedding plants have a summer-only value, but displays can be changed each season.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_vm._v("MAINTENANCE TIME")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Keeping a herbaceous border tidy throughout summer requires more attention than just a border full of shrubs and underplanted with bulbs. Summer-flowering bedding plants also need regular care, including pulling out weeds, watering and removing dead flowers and invasive stems.")])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f81905d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter01.vue
// module id = 72
// module chunks = 0